import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { shippingInfoStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitShippingInfo";
import getColor from "@insite/mobius/utilities/getColor";
import CustomExpandDown from "@tSurya/Icons/CustomExpandDown";
import CustomExpandUp from "@tSurya/Icons/CustomExpandUp";
import { css } from "styled-components";

shippingInfoStyles.shippingInfoAccordionSection = {
    titleTypographyProps: {
        weight: 700,
        css: css`
            font-size: 18px;
            line-height: 26px;
        `,
    },
    headerProps: {
        css: css`
            button {
                background: ${getColor("common.backgroundContrast")};
                padding: 15px 20px;
                border: none;
                &:focus {
                    padding: 15px 20px;
                }
            }
        `,
    },
    expandIconProps: {
        src: CustomExpandDown,
        css: css`
            height: 10px;
            width: 18px;
        `,
    },

    collapseIconProps: {
        src: CustomExpandUp,
        css: css`
            height: 10px;
            width: 18px;
        `,
    },
    panelProps: {
        css: css`
            border: none;
            padding: 10px;
        `,
    },
};

shippingInfoStyles.accordion = {
    css: css`
        > dd {
            > div[class^="GridWrapper"] {
                > div[class^="GridOffset"] {
                    width: 100% !important;
                }
            }
        }
    `,
};
